import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

export default function ColumnSearch({
  columnName,
  onSearch,
  placeholder = "Search...",
  columnKey,
  onSort,
  sortConfig,
  isDate = false,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      let finalQuery = searchQuery;

      // If it's a date field, format the date
      if (isDate && searchQuery) {
        try {
          const date = new Date(searchQuery);
          if (!isNaN(date.getTime())) {
            finalQuery = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
          }
        } catch (error) {
          console.error("Invalid date format:", error);
        }
      }

      onSearch(columnKey, finalQuery);
    }
  };

  const handleSort = () => {
    if (onSort) {
      const newDirection =
        sortConfig?.key === columnKey && sortConfig?.direction === "asc"
          ? "desc"
          : "asc";
      onSort(columnKey, newDirection);
    }
  };

  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };

  return (
    <div className="flex items-center flex-col">
      <div className="flex items-center gap-2">
        <span onClick={handleSort} className="cursor-pointer">
          {columnName}
        </span>
        <button
          onClick={toggleInputVisibility}
          className="p-1 hover:bg-gray-100 rounded-full"
        >
          <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
        </button>
      </div>
      {isInputVisible && (
        <input
          type={isDate ? "date" : "text"}
          className="w-36 px-2 py-1 text-xs border-0 focus:ring-0 text-black focus:outline-none rounded-md"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={handleSearch}
          lang={isDate ? "en-GB" : undefined}
          data-date-format={isDate ? "dd/mm/yyyy" : undefined}
        />
      )}
    </div>
  );
}
